/* ==========================================================================
   THE HER GALLERY — Theme JavaScript
   Version: 1.0.0
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- UTILITY HELPERS ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts || false); }
  function off(el, evt, fn, opts) { if (el) el.removeEventListener(evt, fn, opts || false); }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (parseInt(cents, 10) / 100).toFixed(2);
    var format = window.moneyFormat || 'Rs.{{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var self = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  /* ---------- STICKY HEADER ---------- */
  var headerSection = qs('.header-section');
  if (headerSection) {
    var lastScroll = 0;
    on(window, 'scroll', function () {
      var y = window.scrollY;
      if (y > 50) {
        headerSection.classList.add('is-scrolled');
      } else {
        headerSection.classList.remove('is-scrolled');
      }
      lastScroll = y;
    }, { passive: true });
  }

  /* ---------- BACK TO TOP ---------- */
  var backBtn = qs('#backToTop');
  if (backBtn) {
    on(window, 'scroll', function () {
      if (window.scrollY > 500) {
        backBtn.classList.add('is-visible');
      } else {
        backBtn.classList.remove('is-visible');
      }
    }, { passive: true });
    on(backBtn, 'click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- OVERLAY BACKDROP ---------- */
  var backdrop = qs('#overlayBackdrop');
  function showBackdrop(cb) {
    if (backdrop) {
      backdrop.classList.add('is-active');
      on(backdrop, 'click', function handler() {
        off(backdrop, 'click', handler);
        if (cb) cb();
      });
    }
    document.body.style.overflow = 'hidden';
  }
  function hideBackdrop() {
    if (backdrop) backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* ---------- MOBILE MENU ---------- */
  var mobileMenu = qs('#mobileMenu');
  var mobileMenuToggle = qs('#mobileMenuToggle');
  var mobileMenuClose = qs('#mobileMenuClose');

  function openMobileMenu() {
    if (!mobileMenu) return;

    var headerEnd = 0;
    var headerSec = qs('.header-section');
    if (headerSec) {
      headerEnd = headerSec.getBoundingClientRect().bottom;
      if (headerEnd < 0) headerEnd = 0;
    }
    document.documentElement.style.setProperty('--header-height', headerEnd + 'px');

    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    showBackdrop(closeMobileMenu);
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hideBackdrop();
  }

  on(mobileMenuToggle, 'click', openMobileMenu);
  on(mobileMenuClose, 'click', closeMobileMenu);

  /* Mobile submenu toggles */
  qsa('.mobile-menu__toggle').forEach(function (btn) {
    on(btn, 'click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
    });
  });

  /* ---------- SEARCH OVERLAY ---------- */
  var searchOverlay = qs('#searchOverlay');
  var searchToggle = qs('#searchToggle');
  var searchClose = qs('#searchClose');
  var searchBackdrop = qs('#searchBackdrop');
  var searchInput = qs('#searchInput');
  var searchResults = qs('#searchResults');
  var activeResultIndex = -1;

  /* Also bind any bottom-nav or mobile search triggers */
  var searchToggleMobile = qs('#bottomNavSearch');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
    activeResultIndex = -1;
  }

  on(searchToggle, 'click', openSearch);
  on(searchClose, 'click', closeSearch);
  on(searchBackdrop, 'click', closeSearch);
  on(searchToggleMobile, 'click', function (e) {
    e.preventDefault();
    openSearch();
  });

  function clearSuggestions() {
    if (searchResults) searchResults.innerHTML = '';
    activeResultIndex = -1;
  }

  function highlightResult(index) {
    if (!searchResults) return;
    var items = qsa('.search-overlay__result-item', searchResults);
    items.forEach(function (item, i) {
      item.classList.toggle('is-highlighted', i === index);
    });
  }

  /* Predictive search with 250ms debounce */
  if (searchInput && searchResults) {
    var searchDebounceTimer;

    on(searchInput, 'input', function () {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function () {
        var q = searchInput.value.trim();
        if (q.length < 2) {
          clearSuggestions();
          return;
        }

        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
          .then(function (data) {
            if (!data || !data.resources || !data.resources.results || !data.resources.results.products) {
              searchResults.innerHTML = '<div class="search-overlay__no-results">No results found for \u201c' + escapeHtml(q) + '\u201d</div>';
              return;
            }
            var products = data.resources.results.products;
            if (products.length === 0) {
              searchResults.innerHTML = '<div class="search-overlay__no-results">No results found for \u201c' + escapeHtml(q) + '\u201d</div>';
              return;
            }
            activeResultIndex = -1;
            var html = '';
            products.forEach(function (p) {
              var img = p.image || p.featured_image;
              var imgUrl = img ? (typeof img === 'string' ? img : img.url) : '';
              html += '<a href="' + p.url + '" class="search-overlay__result-item">';
              if (imgUrl) {
                html += '<div class="search-overlay__result-image"><img src="' + imgUrl + '" alt="" width="40" height="40" loading="lazy"></div>';
              }
              html += '<div class="search-overlay__result-info">';
              html += '<div class="search-overlay__result-title">' + escapeHtml(p.title) + '</div>';
              html += '<div class="search-overlay__result-price">' + formatMoney(p.price) + '</div>';
              html += '</div></a>';
            });
            searchResults.innerHTML = html;
          });
      }, 250);
    });

    /* Keyboard navigation: arrows, enter, escape */
    on(searchInput, 'keydown', function (e) {
      var items = qsa('.search-overlay__result-item', searchResults);
      if (items.length === 0) {
        if (e.key === 'Escape') { closeSearch(); }
        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeResultIndex = Math.min(activeResultIndex + 1, items.length - 1);
        highlightResult(activeResultIndex);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeResultIndex = Math.max(activeResultIndex - 1, -1);
        highlightResult(activeResultIndex);
      } else if (e.key === 'Enter') {
        if (activeResultIndex >= 0 && items[activeResultIndex]) {
          e.preventDefault();
          window.location.href = items[activeResultIndex].getAttribute('href');
        }
        /* If no result highlighted, let the form submit naturally */
      } else if (e.key === 'Escape') {
        closeSearch();
      }
    });
  }

  /* ---------- CART DRAWER ---------- */
  var cartDrawer = qs('#cartDrawer');
  var cartToggle = qs('#cartToggle');
  var cartDrawerClose = qs('#cartDrawerClose');
  var cartDrawerItems = qs('#cartDrawerItems');
  var cartDrawerEmpty = qs('#cartDrawerEmpty');
  var cartDrawerFooter = qs('#cartDrawerFooter');
  var cartDrawerSubtotal = qs('#cartDrawerSubtotal');
  var cartCount = qs('#cartCount');
  var cartShippingText = qs('#cartShippingText');
  var cartShippingProgress = qs('#cartShippingProgress');
  var cartDrawerContinue = qs('#cartDrawerContinue');

  function openCartDrawer() {
    if (!cartDrawer) return;
    fetchCart().then(renderCartDrawer);
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    showBackdrop(closeCartDrawer);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    hideBackdrop();
  }

  on(cartToggle, 'click', openCartDrawer);
  on(cartDrawerClose, 'click', closeCartDrawer);
  on(cartDrawerContinue, 'click', closeCartDrawer);

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function updateCartCount(count) {
    if (cartCount) cartCount.textContent = count;
    var bottomBadge = qs('#bottomNavCartCount');
    if (bottomBadge) bottomBadge.textContent = count;
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      if (cartDrawerItems) cartDrawerItems.style.display = 'none';
      if (cartDrawerEmpty) { cartDrawerEmpty.style.display = 'flex'; }
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
      var shippingBar = qs('#cartShippingBar');
      if (shippingBar) shippingBar.style.display = 'none';
      return;
    }

    if (cartDrawerItems) cartDrawerItems.style.display = 'block';
    if (cartDrawerEmpty) cartDrawerEmpty.style.display = 'none';
    if (cartDrawerFooter) cartDrawerFooter.style.display = 'block';
    var shippingBarEl = qs('#cartShippingBar');
    if (shippingBarEl) shippingBarEl.style.display = 'block';

    /* Shipping bar */
    var threshold = 300000; /* Rs.3000 = 300000 cents */

    if (cartShippingText && cartShippingProgress) {
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        cartShippingText.textContent = 'You are ' + formatMoney(remaining) + ' away from free shipping!';
        cartShippingProgress.style.width = Math.min((cart.total_price / threshold) * 100, 100) + '%';
      } else {
        cartShippingText.textContent = '🎉 Free shipping unlocked!';
        cartShippingProgress.style.width = '100%';
      }
    }

    /* Cart items */
    var html = '';
    cart.items.forEach(function (item, idx) {
      html += '<div class="cart-drawer__item" data-line="' + (idx + 1) + '">';
      html += '<div class="cart-drawer__item-image">';
      if (item.image) {
        html += '<img src="' + getSizedImageUrl(item.image, '160x') + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="cart-drawer__item-info">';
      html += '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>';
      if (item.variant_title) {
        html += '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>';
      }
      html += '<div class="cart-drawer__item-row">';
      html += '<div class="cart-drawer__qty">';
      html += '<button class="cart-drawer__qty-btn" data-cart-minus="' + (idx + 1) + '">−</button>';
      html += '<span class="cart-drawer__qty-val">' + item.quantity + '</span>';
      html += '<button class="cart-drawer__qty-btn" data-cart-plus="' + (idx + 1) + '">+</button>';
      html += '</div>';
      html += '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</div>';
      html += '</div>';
      html += '<button class="cart-drawer__item-remove" data-cart-remove="' + (idx + 1) + '" aria-label="Remove"></button>';
      html += '</div>';
    });

    if (cartDrawerItems) cartDrawerItems.innerHTML = html;
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);

    /* Bind events */
    qsa('[data-cart-minus]', cartDrawerItems).forEach(function (btn) {
      on(btn, 'click', function () {
        var line = parseInt(btn.dataset.cartMinus, 10);
        var item = cart.items[line - 1];
        if (item) changeCartItem(line, Math.max(0, item.quantity - 1));
      });
    });

    qsa('[data-cart-plus]', cartDrawerItems).forEach(function (btn) {
      on(btn, 'click', function () {
        var line = parseInt(btn.dataset.cartPlus, 10);
        var item = cart.items[line - 1];
        if (item) changeCartItem(line, item.quantity + 1);
      });
    });

    qsa('[data-cart-remove]', cartDrawerItems).forEach(function (btn) {
      on(btn, 'click', function () {
        var line = parseInt(btn.dataset.cartRemove, 10);
        changeCartItem(line, 0);
      });
    });
  }

  function changeCartItem(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCartDrawer();
      });
  }

  function getSizedImageUrl(src, size) {
    if (!src) return '';
    if (src.indexOf('_' + size) > -1) return src;
    var dotIndex = src.lastIndexOf('.');
    if (dotIndex === -1) return src;
    return src.substring(0, dotIndex) + '_' + size + src.substring(dotIndex);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* AJAX Add to Cart for product cards */
  on(document, 'submit', function (e) {
    var form = e.target.closest('.product-card__form');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var id = formData.get('id');
    var qty = parseInt(formData.get('quantity'), 10) || 1;
    addToCart(id, qty);
  });

  /* ---------- SLIDESHOW ---------- */
  var slideshow = qs('#slideshow');
  if (slideshow) {
    var slides = qsa('.slideshow__slide', slideshow);
    var dots = qsa('.slideshow__dot', slideshow);
    var prevBtn = qs('#slideshowPrev', slideshow);
    var nextBtn = qs('#slideshowNext', slideshow);
    var currentSlide = 0;
    var totalSlides = slides.length;
    var autoplay = slideshow.dataset.autoplay === 'true';
    var interval = (parseInt(slideshow.dataset.interval, 10) || 4) * 1000;
    var autoTimer = null;

    function goToSlide(idx) {
      slides.forEach(function (s) { s.classList.remove('slideshow__slide--active'); });
      dots.forEach(function (d) { d.classList.remove('slideshow__dot--active'); });
      currentSlide = ((idx % totalSlides) + totalSlides) % totalSlides;
      slides[currentSlide].classList.add('slideshow__slide--active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('slideshow__dot--active');
    }

    function nextSlide() { goToSlide(currentSlide + 1); }
    function prevSlide() { goToSlide(currentSlide - 1); }

    function startAutoplay() {
      if (autoplay && totalSlides > 1) {
        autoTimer = setInterval(nextSlide, interval);
      }
    }

    function stopAutoplay() {
      if (autoTimer) clearInterval(autoTimer);
    }

    on(nextBtn, 'click', function () { stopAutoplay(); nextSlide(); startAutoplay(); });
    on(prevBtn, 'click', function () { stopAutoplay(); prevSlide(); startAutoplay(); });

    dots.forEach(function (dot) {
      on(dot, 'click', function () {
        stopAutoplay();
        goToSlide(parseInt(dot.dataset.dotIndex, 10));
        startAutoplay();
      });
    });

    /* Touch swipe for mobile */
    var touchStartX = 0;
    var touchEndX = 0;

    on(slideshow, 'touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    on(slideshow, 'touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        stopAutoplay();
        if (diff > 0) nextSlide(); else prevSlide();
        startAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  }

  /* ---------- TESTIMONIALS CAROUSEL ---------- */
  var testTrack = qs('#testimonialsTrack');
  var testPrev = qs('#testimonialsPrev');
  var testNext = qs('#testimonialsNext');

  if (testTrack) {
    var testCards = qsa('.testimonials__card', testTrack);
    var testIndex = 0;
    var testVisibleCount = 3;

    function getTestVisibleCount() {
      var w = window.innerWidth;
      if (w <= 768) return 1;
      if (w <= 1024) return 2;
      return 3;
    }

    function updateTestCarousel() {
      testVisibleCount = getTestVisibleCount();
      var maxIndex = Math.max(0, testCards.length - testVisibleCount);
      testIndex = Math.min(testIndex, maxIndex);
      var cardWidth = testCards[0] ? testCards[0].offsetWidth + 20 : 0;
      testTrack.style.transform = 'translateX(-' + (testIndex * cardWidth) + 'px)';
    }

    on(testNext, 'click', function () {
      testIndex++;
      var max = Math.max(0, testCards.length - getTestVisibleCount());
      if (testIndex > max) testIndex = 0;
      updateTestCarousel();
    });

    on(testPrev, 'click', function () {
      testIndex--;
      if (testIndex < 0) testIndex = Math.max(0, testCards.length - getTestVisibleCount());
      updateTestCarousel();
    });

    on(window, 'resize', debounce(updateTestCarousel, 200));

    /* Touch swipe */
    var ttsx = 0;
    on(testTrack, 'touchstart', function (e) { ttsx = e.changedTouches[0].screenX; }, { passive: true });
    on(testTrack, 'touchend', function (e) {
      var diff = ttsx - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) testNext.click(); else testPrev.click();
      }
    }, { passive: true });
  }

  /* ---------- QUICK VIEW ---------- */
  var quickViewModal = qs('#quickViewModal');
  var quickViewBody = qs('#quickViewBody');

  function openQuickView(handle) {
    if (!quickViewModal || !quickViewBody) return;
    quickViewModal.classList.add('is-open');
    quickViewModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    quickViewBody.innerHTML = '<div class="quick-view-modal__loading"><div class="spinner"></div></div>';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var firstVariant = product.variants[0];
        var onSale = firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price;

        var html = '<div class="quick-view__grid">';

        /* Image */
        html += '<div class="quick-view__image">';
        if (product.featured_image) {
          html += '<img src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '" width="500" height="500">';
        }
        html += '</div>';

        /* Info */
        html += '<div class="quick-view__info">';
        html += '<h2 class="quick-view__title">' + escapeHtml(product.title) + '</h2>';

        /* Price */
        html += '<div class="quick-view__price">';
        if (onSale) {
          html += '<span class="quick-view__price--sale">' + formatMoney(firstVariant.price) + '</span>';
          html += '<span class="quick-view__price--compare">' + formatMoney(firstVariant.compare_at_price) + '</span>';
        } else {
          html += '<span>' + formatMoney(firstVariant.price) + '</span>';
        }
        html += '</div>';

        /* Variants */
        if (product.variants.length > 1) {
          html += '<div class="quick-view__variants" id="qvVariants">';
          product.variants.forEach(function (v, i) {
            html += '<button class="quick-view__variant-btn' + (i === 0 ? ' is-active' : '') + '" data-variant-id="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || '') + '">' + escapeHtml(v.title) + '</button>';
          });
          html += '</div>';
        }

        /* ATC */
        html += '<button class="btn btn--primary" id="qvAddToCart" data-variant-id="' + firstVariant.id + '" style="margin-top:16px;">Add to Cart</button>';
        html += '</div></div>';

        quickViewBody.innerHTML = html;

        /* Variant selection */
        qsa('.quick-view__variant-btn', quickViewBody).forEach(function (btn) {
          on(btn, 'click', function () {
            qsa('.quick-view__variant-btn', quickViewBody).forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            var atcBtn = qs('#qvAddToCart');
            if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;

            /* Update price */
            var priceEl = qs('.quick-view__price', quickViewBody);
            if (priceEl) {
              var priceHtml = '';
              if (btn.dataset.compare && parseInt(btn.dataset.compare, 10) > parseInt(btn.dataset.price, 10)) {
                priceHtml = '<span class="quick-view__price--sale">' + formatMoney(btn.dataset.price) + '</span>';
                priceHtml += '<span class="quick-view__price--compare">' + formatMoney(btn.dataset.compare) + '</span>';
              } else {
                priceHtml = '<span>' + formatMoney(btn.dataset.price) + '</span>';
              }
              priceEl.innerHTML = priceHtml;
            }
          });
        });

        /* ATC Button */
        var qvAtc = qs('#qvAddToCart', quickViewBody);
        if (qvAtc) {
          on(qvAtc, 'click', function () {
            addToCart(parseInt(qvAtc.dataset.variantId, 10), 1).then(function () {
              closeQuickView();
            });
          });
        }
      })
      .catch(function () {
        quickViewBody.innerHTML = '<p style="text-align:center;padding:40px;color:#999;">Unable to load product details.</p>';
      });
  }

  function closeQuickView() {
    if (!quickViewModal) return;
    quickViewModal.classList.remove('is-open');
    quickViewModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (btn) {
      e.preventDefault();
      openQuickView(btn.dataset.productHandle);
    }
    if (e.target.closest('[data-quick-view-close]')) {
      closeQuickView();
    }
  });

  /* ---------- PRODUCT TEMPLATE — VARIANT SELECTOR ---------- */
  var productForm = qs('#productForm');
  if (productForm) {
    var productJSON = qs('#productJSON');
    var productData = productJSON ? JSON.parse(productJSON.textContent) : null;

    if (productData) {
      qsa('.product-template__option-btn').forEach(function (btn) {
        on(btn, 'click', function () {
          /* Toggle active within same option group */
          var pos = btn.dataset.optionPosition;
          qsa('.product-template__option-btn[data-option-position="' + pos + '"]').forEach(function (b) {
            b.classList.remove('product-template__option-btn--active');
          });
          btn.classList.add('product-template__option-btn--active');

          /* Build selected options */
          var selected = [];
          productData.options.forEach(function (opt, i) {
            var activeBtn = qs('.product-template__option-btn--active[data-option-position="' + (i + 1) + '"]');
            selected.push(activeBtn ? activeBtn.dataset.optionValue : opt);
          });

          /* Find matching variant */
          var variant = productData.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === selected[i]; });
          });

          if (variant) {
            qs('#productVariantId').value = variant.id;
            var priceEl = qs('#productPrice');
            if (priceEl) {
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                priceEl.innerHTML = '<span class="product-template__price--sale">' + formatMoney(variant.price) + '</span><span class="product-template__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
              } else {
                priceEl.innerHTML = '<span class="product-template__price--regular">' + formatMoney(variant.price) + '</span>';
              }
            }

            var atcBtn = qs('#productAddToCart');
            if (atcBtn) {
              if (variant.available) {
                atcBtn.disabled = false;
                atcBtn.textContent = 'Add to Cart';
              } else {
                atcBtn.disabled = true;
                atcBtn.textContent = 'Sold Out';
              }
            }

            /* Update image */
            if (variant.featured_image) {
              var mainImg = qs('#productImage');
              if (mainImg) mainImg.src = variant.featured_image.src;
            }
          }
        });
      });
    }

    /* AJAX Add to Cart on product page */
    on(productForm, 'submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var id = formData.get('id');
      var qty = parseInt(formData.get('quantity'), 10) || 1;
      addToCart(id, qty);
    });
  }

  /* Quantity Buttons */
  qsa('[data-qty-plus]').forEach(function (btn) {
    on(btn, 'click', function () {
      var input = btn.parentElement.querySelector('.product-template__qty-input');
      if (input) input.value = Math.max(1, parseInt(input.value, 10) + 1);
    });
  });

  qsa('[data-qty-minus]').forEach(function (btn) {
    on(btn, 'click', function () {
      var input = btn.parentElement.querySelector('.product-template__qty-input');
      if (input) input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  });

  /* Sticky Mobile ATC */
  var stickyAtc = qs('#stickyAtc');
  var stickyAtcBtn = qs('#stickyAtcBtn');
  var mainAtcBtn = qs('#productAddToCart');

  if (stickyAtc && mainAtcBtn) {
    on(window, 'scroll', function () {
      var rect = mainAtcBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyAtc.classList.add('is-visible');
      } else {
        stickyAtc.classList.remove('is-visible');
      }
    }, { passive: true });

    if (stickyAtcBtn) {
      on(stickyAtcBtn, 'click', function () {
        mainAtcBtn.click();
      });
    }
  }

  /* Product Thumbnail Gallery */
  qsa('.product-template__thumb').forEach(function (thumb) {
    on(thumb, 'click', function () {
      qsa('.product-template__thumb').forEach(function (t) { t.classList.remove('product-template__thumb--active'); });
      thumb.classList.add('product-template__thumb--active');
      var mainImg = qs('#productImage');
      if (mainImg && thumb.dataset.imageUrl) {
        mainImg.src = thumb.dataset.imageUrl;
      }
    });
  });

  /* ---------- COLLECTION SORT ---------- */
  var sortSelect = qs('#sortBy');
  if (sortSelect) {
    on(sortSelect, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- CART PAGE QUANTITY BUTTONS ---------- */
  qsa('[data-line-plus]').forEach(function (btn) {
    on(btn, 'click', function () {
      var line = btn.dataset.linePlus;
      var input = qs('[data-line-qty="' + line + '"]');
      if (input) {
        input.value = parseInt(input.value, 10) + 1;
        updateCartLine(parseInt(line, 10), parseInt(input.value, 10));
      }
    });
  });

  qsa('[data-line-minus]').forEach(function (btn) {
    on(btn, 'click', function () {
      var line = btn.dataset.lineMinus;
      var input = qs('[data-line-qty="' + line + '"]');
      if (input) {
        var newVal = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = newVal;
        updateCartLine(parseInt(line, 10), newVal);
      }
    });
  });

  qsa('[data-line-remove]').forEach(function (btn) {
    on(btn, 'click', function () {
      var line = parseInt(btn.dataset.lineRemove, 10);
      updateCartLine(line, 0);
    });
  });

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { window.location.reload(); });
  }

  /* ---------- INTERSECTION OBSERVER — FADE IN ---------- */
  if ('IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    qsa('.fade-in-up').forEach(function (el) {
      fadeObserver.observe(el);
    });
  } else {
    /* Fallback — show everything */
    qsa('.fade-in-up').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ---------- ESCAPE KEY HANDLER ---------- */
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeSearch();
      closeMobileMenu();
      closeQuickView();
    }
  });

  /* ---------- PRODUCT SLIDERS ("Pause then Slide" Carousel) ---------- */
  var SLIDE_INTERVAL = 3000;   // stay still for 3 seconds
  var SLIDE_DURATION = 600;    // slide transition takes 0.6s
  var isMobile = function () { return window.innerWidth <= 768; };

  qsa('.product-slider').forEach(function (slider) {
    var track = qs('[data-slider-track]', slider);
    if (!track) return;

    var originalSlides = qsa('.product-slider__slide', track);
    if (originalSlides.length === 0) return;

    var prevArrow = qs('.product-slider__arrow--prev', slider);
    var nextArrow = qs('.product-slider__arrow--next', slider);

    // Clone slides at the end for seamless looping (desktop only)
    var originalCount = originalSlides.length;
    originalSlides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('product-slider__slide--clone');
      track.appendChild(clone);
    });

    var currentIndex = 0;
    var intervalId = null;
    var isHovered = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartTranslate = 0;

    function getSlideWidth() {
      var firstSlide = qs('.product-slider__slide', track);
      if (!firstSlide) return 0;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 20;
      return firstSlide.offsetWidth + gap;
    }

    function getVisibleCount() {
      var viewport = qs('.product-slider__viewport', slider);
      if (!viewport) return 4;
      var slideW = getSlideWidth();
      if (slideW === 0) return 4;
      return Math.round(viewport.offsetWidth / slideW);
    }

    function slideTo(idx, animate) {
      if (isMobile()) return; // mobile is grid, skip
      var slideW = getSlideWidth();
      var translate = idx * slideW;

      if (animate !== false) {
        track.style.transition = 'transform ' + SLIDE_DURATION + 'ms cubic-bezier(0.4, 0, 0.2, 1)';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translateX(-' + translate + 'px)';
    }

    function slideNext() {
      if (isMobile()) return;
      currentIndex++;
      slideTo(currentIndex, true);

      // After transition, if we've scrolled into clone territory, snap back
      setTimeout(function () {
        if (currentIndex >= originalCount) {
          currentIndex = 0;
          slideTo(0, false);
        }
      }, SLIDE_DURATION + 50);
    }

    function slidePrev() {
      if (isMobile()) return;
      if (currentIndex <= 0) {
        // Jump to end of real slides (no animation), then slide back
        currentIndex = originalCount;
        slideTo(currentIndex, false);
        // Force reflow
        void track.offsetHeight;
        currentIndex = originalCount - 1;
        slideTo(currentIndex, true);
      } else {
        currentIndex--;
        slideTo(currentIndex, true);
      }
    }

    function startInterval() {
      stopInterval();
      if (isMobile()) return;

      // Do not auto-play the categories slider
      if (slider.classList.contains('categories-slider')) return;

      intervalId = setInterval(function () {
        if (!isHovered && !isDragging) {
          slideNext();
        }
      }, SLIDE_INTERVAL);
    }

    function stopInterval() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function resetMobile() {
      // On mobile, sliders become grids — reset transform
      if (isMobile()) {
        stopInterval();
        track.style.transform = '';
        track.style.transition = '';
      } else {
        slideTo(currentIndex, false);
        startInterval();
      }
    }

    // Pause on hover (desktop)
    on(slider, 'mouseenter', function () {
      isHovered = true;
    });
    on(slider, 'mouseleave', function () {
      isHovered = false;
    });

    // Arrow buttons
    if (prevArrow) {
      on(prevArrow, 'click', function () {
        slidePrev();
        startInterval(); // reset timer
      });
    }
    if (nextArrow) {
      on(nextArrow, 'click', function () {
        slideNext();
        startInterval(); // reset timer
      });
    }

    // Touch/Drag swipe (desktop carousel only)
    function onDragStart(e) {
      if (isMobile()) return;
      if (e.type === 'mousedown') e.preventDefault();
      isDragging = true;
      dragStartX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      var matrix = getComputedStyle(track).transform;
      if (matrix && matrix !== 'none') {
        var values = matrix.match(/matrix.*\((.+)\)/);
        if (values) {
          var parts = values[1].split(',');
          dragStartTranslate = parseFloat(parts[4]) || 0;
        } else {
          dragStartTranslate = 0;
        }
      } else {
        dragStartTranslate = 0;
      }
      track.style.transition = 'none';
      track.classList.add('is-dragging');
      stopInterval();
    }

    function onDragMove(e) {
      if (!isDragging) return;
      var x = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      var diff = x - dragStartX;
      track.style.transform = 'translateX(' + (dragStartTranslate + diff) + 'px)';
    }

    function onDragEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');

      var x = e.type === 'touchend'
        ? (e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : dragStartX)
        : e.clientX;
      var diff = x - dragStartX;
      var slideW = getSlideWidth();

      if (Math.abs(diff) > slideW * 0.2) {
        if (diff < 0) {
          slideNext();
        } else {
          slidePrev();
        }
      } else {
        slideTo(currentIndex, true);
      }
      startInterval();
    }

    on(track, 'mousedown', onDragStart);
    on(document, 'mousemove', onDragMove);
    on(document, 'mouseup', onDragEnd);
    on(track, 'touchstart', onDragStart, { passive: true });
    on(track, 'touchmove', onDragMove, { passive: true });
    on(track, 'touchend', onDragEnd, { passive: true });

    // Initialize
    setTimeout(function () {
      resetMobile();
    }, 200);

    // Handle resize between mobile/desktop
    window.addEventListener('resize', debounce(function () {
      resetMobile();
    }, 250));
  });

  /* ---------- BOTTOM NAV — Cart Button ---------- */
  var bottomNavCart = qs('#bottomNavCart');
  if (bottomNavCart) {
    on(bottomNavCart, 'click', function () {
      openCartDrawer();
    });
  }

  // Keep bottom nav cart badge synced
  function updateBottomNavCount(count) {
    var badge = qs('#bottomNavCartCount');
    if (badge) badge.textContent = count;
  }

  // Patch updateCartCount to also update bottom nav
  var _origUpdateCartCount = typeof updateCartCount === 'function' ? updateCartCount : null;

  /* ---------- FOOTER ACCORDION (mobile) ---------- */
  qsa('.footer__col:not(.footer__col--brand) .footer__col-title').forEach(function (title) {
    on(title, 'click', function () {
      if (window.innerWidth > 768) return;
      var col = title.closest('.footer__col');
      if (col) col.classList.toggle('is-open');
    });
  });

  /* ---------- INITIAL CART COUNT ---------- */
  fetchCart().then(function (cart) {
    updateCartCount(cart.item_count);
    updateBottomNavCount(cart.item_count);
  }).catch(function () { /* silently fail on non-Shopify environments */ });

})();
